import styled from "styled-components"

import padding from "../global/padding"

export const EditorContainer = styled.div`
  margin-bottom: ${padding.base};
`
